<template>
  <ValidationObserver v-slot="validator">
    <div class="modal-card" v-bind="dirtySite">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ modalTitle }}
        </p>
        <button @click="closeModal" type="button" class="close-icon">
          <i class="mdi mdi-close"></i>
        </button>
      </header>
      <section class="modal-card-body">
        <ValidationProvider
          v-slot="{ errors }"
          rules="required|max:255"
          name="Site Name"
        >
          <b-field
            class="label-style"
            label="Site Name"
            :message="errors[0]"
            :type="errors.length ? 'is-danger' : undefined"
          >
            <b-input
              v-model="dirtySite.name"
              placeholder="Name of institution or place to run data collection period"
            ></b-input>
          </b-field>
        </ValidationProvider>

        <b-field class="label-style" label="Address">
          <b-input
            v-model="dirtySite.address"
            placeholder="Address of a medical institution"
          ></b-input>
        </b-field>

        <b-field label="Description" class="no-bottom-margin label-style">
          <b-input
            v-model="dirtySite.description"
            type="textarea"
            placeholder="Description of the site (example : opening hours, phone number)"
          ></b-input>
        </b-field>
        <hr />
        <div class="level">
          <div class="level-left">
            <div class="column padding-none">
              <p class="text-size text-color">
                Sample Code
                <b-tooltip
                  label="Data collection sample code in individual mode."
                  position="is-top"
                  type="is-dark"
                  :class="$style.tooltip"
                >
                  <b-icon
                    icon="information-outline"
                    size="is-small"
                    custom-size="mdi-15px"
                  >
                  </b-icon>
                </b-tooltip>
              </p>
              <p :class="$style.sampleText">
                This attribute setting is optional by default.
              </p>
            </div>
          </div>
          <div class="level-right">
            <b-switch v-model="dirtySite.isIdentifierRequired"
              >Required</b-switch
            >
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-primary is-rounded"
          @click="
            task === 'Edit'
              ? validator.validate().then((validated) => {
                  if (validated === false) return;
                  updateSite();
                })
              : validator.validate().then((validated) => {
                  if (validated === false) return;
                  addSite();
                })
          "
        >
          {{ task === 'Edit' ? 'Save' : 'Add Site' }}
        </button>
      </footer>
    </div>
  </ValidationObserver>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Site } from '@/store/modules/site/types/site.types';
import { Action } from 'vuex-class';
import { cloneDeep as _cloneDeep } from 'lodash';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
  },
})
export default class SiteModal extends Vue {
  @Prop()
  public modalTitle!: string;

  @Prop()
  public task!: string;

  @Prop()
  public siteDetail!: Site;

  public dirtySite: Partial<Site> = {
    id: 0,
    name: '',
    address: '',
    description: '',
    isIdentifierRequired: false,
  };

  public updateSite() {
    this.$emit('editSelectedSite', this.dirtySite);
    this.$emit('close');
  }

  public addSite() {
    this.$emit('addNewSite', this.dirtySite);
    this.$emit('close');
  }

  public closeModal() {
    this.$emit('close');
  }

  public mounted() {
    this.dirtySite = _cloneDeep(this.siteDetail);
  }
}
</script>
<style lang="scss" module>
.sampleText {
  font-size: 14px;
  color: #9f9f9f;
  text-align: justify;
}

.tooltip {
  position: absolute !important;
}
</style>
